import { render, staticRenderFns } from "./MainMenuSidebar.vue?vue&type=template&id=4bfd20e6"
import script from "./MainMenuSidebar.vue?vue&type=script&lang=js"
export * from "./MainMenuSidebar.vue?vue&type=script&lang=js"
import style0 from "./MainMenuSidebar.vue?vue&type=style&index=0&id=4bfd20e6&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports